module.exports = __webpack_public_path__ + "img/office5.fae20091.png";